<template>
    <v-dialog value='true' fullscreen hide-overlay persistent content-class='analise__scroll'>
        <v-card tile color='#fff'>
            <analise-documentacao-cabecalho-credenciamento :key="key" v-model="credenciamento.analiseDocumentos"
                                            @voltar="tratarEventoDeVoltar"/>
            <v-card-text class='analise__area' v-if="credenciamento.analiseDocumentos && credenciamento.analiseDocumentos.documentosAnalizaveis
                                                     && credenciamento.analiseDocumentos.documentosNaoAnalizaveis">
                <analise-documentacao-menu-credenciamento v-if="exibir"
                                           v-model="credenciamento.analiseDocumentos"
                                           :situacaoSolicitacaoCredenciamento="credenciamento.analiseDocumentos.situacaoSolicitacaoCredenciamento"
                                           @marcarAnalisado="tratarEventoMarcarAnalisado"
                                           @reload="reloadComponent"
                                           @documentoSelecionado="tratarEventoDeSelecionarDocumento"/>
                <analise-documentacao-documento-credenciamento v-if="exibir"
                                                :documento="documentoSelecionado"
                                                :situacaoSolicitacaoCredenciamento="credenciamento.analiseDocumentos.situacaoSolicitacaoCredenciamento"
                                                :situacaoItemLote="credenciamento.analiseDocumentos.situacaoItemLote"
                                                :situacaoFornecedor="credenciamento.analiseDocumentos.situacaoFornecedor"
                                                :itemLoteTipo="itemLoteTipo"
                                                :virtualizacao="true"
                                                @aprovarDocumentoReenviado="tratarEventoMarcarAnalisado"
                                                @solicitarReenvio="tratarEventoDeSolicitarReenvio"
                                                @downloadDocumento="tratarEventoDownload"
                                                @solicitarAssinatura="solicitarAssinatura"/>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import AnaliseDocumentacaoCabecalhoCredenciamento
  from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/cabecalho/AnaliseDocumentacaoCabecalhoCredenciamento.vue'
import AnaliseDocumentacaoMenuCredenciamento from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/menu/AnaliseDocumentacaoMenuCredenciamento.vue'
import AnaliseDocumentacaoDocumentoCredenciamento
  from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/documento/AnaliseDocumentacaoDocumentoCredenciamento.vue'
import {actionTypes} from '@/commons/constants'

export default {
    name: 'AnaliseDocumentacaoCredenciamento',
    components: {
      AnaliseDocumentacaoCabecalhoCredenciamento,
      AnaliseDocumentacaoDocumentoCredenciamento,
      AnaliseDocumentacaoMenuCredenciamento
    },
    data() {
        return {
            credenciamentoId: null,
            fornecedorId: null,
            itemLoteId: null,
            itemLoteTipo: null,
            documentoSelecionado: {
                url: ''
            },
            exibir: false,
           credenciamento: {
                analiseDocumentos: {
                    analiseSolicitacaoCredenciamentoId: null,
                    numeroProcesso: '',
                    orgao: '',
                    razaoSocial: '',
                    documentosAnalizaveis: [],
                    documentosNaoAnalizaveis: [],
                    situacaoSolicitacaoCredenciamento: '',
                    situacaoItemLote: '',
                    situacaoFornecedor: '',
                    motivoNaoCredenciamento: '',
                }
           },
          key: 0,
        }
    },
    computed: {
        ...mapState(['parametros','loki', 'licitacao', 'analiseSolicitacaoCredenciamentoEmAnalise', 'participante'])
    },
    async mounted() {
        try {
            this.receberDadosDaRota()
            await this.buscarDadosCabecalhoAnaliseDocumentacao()
            await this.buscarDocumentosParaAnalisar()
            await this.exibirAnalise()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        ...mapActions({
              buscarDocumentosAnaliseSolicitacaoCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DOCUMENTOS_ANALISE_SOLICITACAO_CREDENCIAMENTO,
              buscarDadosCabecalhoCredenciamento: actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DADOS_CABECALHO_CREDENCIAMENTO
        }),

      formatarDocumentosParaCredenciamento(data) {
        return data.anexos.map((item) => {
          return {
            id: item.id,
            uri: item.anexoUri,
            url: '/hal/public/arquivos?uri=' + item.anexoUri + '&thumbnail=false',
            situacao: item.situacao ? item.situacao : 'AGUARDANDO_ANALISE',
            documentoSolicitadoId: item.solicitacaoCredenciamentoId,
            descricao: item.descricao,
            motivoReenvio: item.motivoReenvio,
            nomeFornecedor: item.nomeFornecedor,
            assinaturaSolicitada: item.assinaturaSolicitada,
            assinado: item.assinado,
            idVirtualizado: item.idVirtualizado,
          }
        });
      },

      formatarRelatoriosParaCredenciamento(data) {
        return data.relatorios.map((item) => {
          return {
            id: item.id,
            anexoUri: item.anexoUri,
            uri: item.anexoUri,
            url: '/hal/public/arquivos?uri=' + item.anexoUri + '&thumbnail=false',
            situacao: item.situacao ? item.situacao : 'AGUARDANDO_ANALISE',
            documentoSolicitadoId: item.solicitacaoCredenciamentoId,
            descricao: item.descricao,
            motivoReenvio: item.motivoReenvio,
            nomeFornecedor: item.nomeFornecedor,
            assinaturaSolicitada: item.assinaturaSolicitada,
            assinado: item.assinado,
            idVirtualizado: item.idVirtualizado,
          }
        });
      },

      async buscarDadosCabecalhoAnaliseDocumentacao(){
        const dados = {
          licitacaoId: this.credenciamentoId,
          idSolicitacao: parseInt(this.$route.params.idSolicitacao)
        }
        await this.buscarDadosCabecalhoCredenciamento(dados).then((response) => {
          this.credenciamento.analiseDocumentos.analiseSolicitacaoCredenciamentoId = this.$route.params.idAnaliseSolicitacao
          this.credenciamento.analiseDocumentos.numeroProcesso = response.data.numeroProcesso
          this.credenciamento.analiseDocumentos.fornecedor = response.data.solicitacaoCredenciamento.fornecedor
          this.credenciamento.analiseDocumentos.situacaoSolicitacaoCredenciamento = response.data.solicitacaoCredenciamento.situacao
        })

      },
      async buscarDocumentosParaAnalisar() {
            const dados = {
                licitacaoId: this.credenciamentoId,
                solicitacaoId: parseInt(this.$route.params.idSolicitacao)
            }

            const data = await this.buscarDocumentosAnaliseSolicitacaoCredenciamento(dados)
            this.credenciamento.analiseDocumentos.documentosAnalizaveis = this.formatarDocumentosParaCredenciamento(data)
            this.credenciamento.analiseDocumentos.documentosNaoAnalizaveis = this.formatarRelatoriosParaCredenciamento(data)
      },
      async tratarEventoDeSelecionarDocumento(comboAnaliseDocumentacaoMenu) {
            this.documentoSelecionado = comboAnaliseDocumentacaoMenu
      },
      async tratarEventoDeSolicitarReenvio(documento) {
          const dados = {
              credenciamentoId: this.credenciamentoId,
              solicitacaoId: documento.documentoSolicitadoId,
              documentoId: documento.id,
              motivoReenvio: documento.motivoReenvio,
              situacao: 'AGUARDANDO_REENVIO'
          }
          const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.ALTERAR_SITUACAO_DOCUMENTO_CREDENCIAMENTO, dados)

          if(response.status === 200)
              this.documentoSelecionado.situacao = response.data.situacao
          else
              throw new Error('Ocorreu um erro no processamento da requisição, por favor, tente novamente.')
      },
        async tratarEventoMarcarAnalisado(documento) {
            this.documentoSelecionado = documento
            const dados = {
                credenciamentoId: this.credenciamentoId,
                solicitacaoId: documento.documentoSolicitadoId,
                documentoId: documento.id,
                motivoReenvio: documento.motivoReenvio,
                situacao: 'ANALISADO'
            }
            const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.ALTERAR_SITUACAO_DOCUMENTO_CREDENCIAMENTO, dados)

            if(response.status === 200)
                this.documentoSelecionado.situacao = response.data.situacao
            else
                throw new Error('Ocorreu um erro no processamento da requisição, por favor, tente novamente.')
        },
        async exibirAnalise() {
            this.exibir = true
        },
        tratarEventoDownload(documento) {
          this.$store.dispatch(actionTypes.CREDENCIAMENTO.BAIXAR_DOCUMENTO, documento)
        },
        tratarEventoDeVoltar() {
            this.$router.push({
                name: 'CredenciamentoAtualizacaoSelecaoParticipantes',
                params: {
                    id: this.credenciamentoId
                },
                query: {
                    edicao: !!this.$route.query.voltar
                }
            })
        },
        receberDadosDaRota() {
            this.credenciamentoId = this.$route.params.id
        },
        reloadComponent() {
          this.buscarDocumentosParaAnalisar()
        },
        async solicitarAssinatura(documento) {
          this.habilitarLoadingGlobal()
          try {
            const params = {
              solicitacaoCredenciamentoId: documento.documentoSolicitadoId,
            }
            await this.$store.dispatch(actionTypes.CREDENCIAMENTO.SOLICITACAO.SOLICITAR_ASSINATURA, params)
            await this.atualizarDocumentosParaAnalisar()
            this.mostrarNotificacaoSucessoDefault()
            this.$emit('eventUpdate')
            this.desabilitarLoadingGlobal()
          } catch (e) {
            this.desabilitarLoadingGlobal()
          }
        },
        async atualizarDocumentosParaAnalisar() {
          await this.buscarDocumentosParaAnalisar()

          const documentosAnalisaveis = this.credenciamento.analiseDocumentos.documentosAnalizaveis
          const documentosNaoAnalisaveis = this.credenciamento.analiseDocumentos.documentosNaoAnalizaveis

          const documentoAtualNaLista = documentosAnalisaveis.find(doc => doc.id === (this.documentoSelecionado && this.documentoSelecionado.id))
          const documentoAtualNaListaNaoAnalisaveis = documentosNaoAnalisaveis.find(doc => doc.id === (this.documentoSelecionado && this.documentoSelecionado.id))

          if (documentoAtualNaLista) {
            this.documentoSelecionado = { ...documentoAtualNaLista }
          } else if (documentoAtualNaListaNaoAnalisaveis) {
            this.documentoSelecionado = { ...documentoAtualNaListaNaoAnalisaveis }
          } else {
            this.documentoSelecionado = documentosAnalisaveis[0]
          }
        },
    }
}
</script>

<style scoped lang='stylus'>
    .analise__area
        padding 0
        margin 0
        overflow-y auto
        padding-top 64px
        display flex

    @media (max-width 960px)
        .analise__area
            padding-top 48px

    @media (max-width 670px)
        .analise__area
            padding-top 56px
</style>
